import React, { Component } from 'react';
import { Button, Container, Row, Col, Paragraph, InputGroup } from './';
import styled, { css } from 'styled-components';
import HoverMenu from '../js/components/hover-menu';
import axios from 'axios';
import logo from './header/logo';
import Mobile from './header/mobile';
import queryString from 'query-string';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

// eslint-disable-next-line no-unused-vars
const loginData = {
  logged_in: true,
  google_event_category: 'Header Menu',
  google_event_label: 'Homepage',
  user_role: 'advertiser',
  login_area_web_path: 'https://www.homeimprovementpages.com.au/account/',
  session_id: 'la2t0fotf8kupuq5ngffke36k0',
  hostname: 'fe6.prod.aws.viteknologies.com.au',
  friends_web_path: '/feed',
  username: 'Lisheng Payment',
  user_id: 17763145,
  user_thumbnail: '17760001_17765000/17763145',
  message_centre_web_path: 'https://www.homeimprovementpages.com.au/message_centre',
  shortlist_web_path: 'https://www.homeimprovementpages.com.au/account/?m=shortlist',
  user_settings_web_path: 'https://www.homeimprovementpages.com.au/account/?m=user&a=settings',
  num_leads: 878,
  number_messages: 163,
  jobs_web_path: '/account/?m=job',
  inspiration_board_web_path: '/user/17763145/inspirationboards',
  email: 'lishengpayment5@mailinator.com',
  phone: '324234234'
};

import Dropdown from './header/dropdown';
import CategoryDropdown from './header/category-dropdown';
import LoginDropdown from './header/login-dropdown';
import PostcodeAutocomplete from './header/postcode-autocomplete';
import SiteAutocomplete from './header/category-site-autocomplete';
import data from './header/data';

const Logo = styled.div`
  width: 120px;
  height: 44px;
  background: url(${logo}) no-repeat;
  text-indent: -99999px;
  display: block;
`;

const TagLine = Paragraph.extend`
  font-size: 15px;
  margin: 0;
`;

const HeaderList = styled.ul`
  margin-bottom: 0;
  margin-top: 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0;
  padding-bottom: 0;
  text-align: left;
`;

export const HeaderLink = styled.a`
  font-size: 15px;
  color: #333;
  text-decoration: none;
  padding-right: 7px;
  padding-top: 10px;
  padding-bottom: 10px;
  &:hover,
  &:visited {
    color: #555;
  }

  ${props =>
    props.primary &&
    css`
      color: ${props.theme.primary};
      &:hover,
      &:visited {
        color: ${props.theme.primary};
      }
    `};
`;

const LogoWrapper = HeaderLink.extend`
  margin-top: 20px;
  display: block;
`;

// use a to add href fallback for old IE
const SearchIconButton = styled.a`
  text-decoration: none;
  position: absolute;
  padding: 5px;
  margin: 0;
  right: 9px;
  top: 9px;
  color: ${props => props.theme.primary};
`;

// to enable submit form by native ENTER key events
const SubmitButton = styled.button`
  position: absolute;
  right: 0;
  display: none;
`;

export class Header extends Component {
  static propTypes = {
    siteSource: PropTypes.string
  };

  state = {
    postcodeValue: '',
    siteValue: '',
    loginData: {
      logged_in: false
    }
  };

  async componentDidMount() {
    try {
      const { data } = await axios.get('/system/ajax_handlers/user_info.php');
      this.setState({
        loginData: data
      });
      if (typeof window !== 'undefined') {
        // TODO: this should be in redux or something for new header
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          accountId: data.account_id || 0,
          accountType: data.acount_type || 'Unknnown',
          userEmail: data.email || null,
          userID: data.user_id || 0,
          userJobCount: data.job_count || 0,
          userTenure: data.tenure || null,
          userType: data.user_role || 'Anonymous'
        });
      }
    } catch (e) {
      // NOTHINNNGG
    }
  }

  onPostcodeChange = postcodeValue => {
    this.setState({ postcodeValue });
  };

  onSiteChange = siteValue => {
    this.setState({ siteValue });
  };

  onSearchSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    const { postcodeValue, siteValue } = this.state;

    if (!postcodeValue) {
      this.searchForm.querySelector('.search-zip-wrapper input').focus();

      return;
    }

    if (!siteValue) {
      alert('Please enter a Keyword or select a Category to search'); // eslint-disable-line no-alert

      return;
    }

    if (!postcodeValue || !siteValue) {
      return;
    }

    const params = {
      search_str: siteValue,
      search_zip: postcodeValue,
      m: 'search',
      a: 'search_results',
      dosql: 'do_search',
      search_code: 'p',
      search_what_header: 'what',
      search_where_header: 'where',
      loctype: 'zip'
    };

    window.location.href = `/index.php?${queryString.stringify(params)}`;
  };

  render() {
    const { siteSource } = this.props;
    const { postcodeValue, siteValue, loginData } = this.state;
    return (
      <div style={{ background: '#fff' }}>
        <Container style={{ padding: 0 }}>
          <Row flexDirection={'row-reverse'} style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Col xs={0} sm={0} md={7.5} lg={6} style={{ marginTop: 40, textAlign: 'right' }}>
              <form
                onSubmit={this.onSearchSubmit}
                ref={searchForm => {
                  this.searchForm = searchForm;
                }}
              >
                <InputGroup style={{ position: 'relative' }}>
                  <SiteAutocomplete
                    name="search_str"
                    value={siteValue}
                    onChange={this.onSiteChange}
                  />
                  <span className="search-zip-wrapper">
                    <PostcodeAutocomplete
                      name="search_zip"
                      value={postcodeValue}
                      onChange={this.onPostcodeChange}
                    />
                  </span>
                  <SearchIconButton
                    href="/find"
                    onClick={this.onSearchSubmit}
                    data-ga-category={GA_CATEGORY}
                    data-ga-action={`${GA_CATEGORY} - Clicked Search Button`}
                    data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                    className="hui-icon-search"
                  />
                  <SubmitButton type="submit" />
                </InputGroup>
              </form>
            </Col>
            <Col xs={0} sm={0} md={4.5} lg={6}>
              <LogoWrapper
                href="/"
                data-ga-category={GA_CATEGORY}
                data-ga-action={`${GA_CATEGORY} - Clicked Home`}
                data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
              >
                <Logo />
                <TagLine>Australia&apos;s #1 site to hire tradespeople</TagLine>
              </LogoWrapper>
            </Col>
          </Row>
          <Row style={{ marginTop: '5px' }}>
            <Col xs={0} sm={0} md={7.5} style={{ paddingLeft: 10, lineHeight: '39px' }}>
              <HeaderList style={{ paddingRight: 0 }}>
                <HeaderLink
                  primary
                  href="/get_quotes_simple"
                  data-ga-category={GA_CATEGORY}
                  data-ga-action={`${GA_CATEGORY} - Clicked Get Quotes`}
                  data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                  style={{ paddingRight: 13 }}
                >
                  Get Quotes
                </HeaderLink>
                <HoverMenu
                  menuItem={
                    <HeaderLink
                      href="/find"
                      data-ga-category={GA_CATEGORY}
                      data-ga-action={`${GA_CATEGORY} - Clicked Trade Categories`}
                      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                    >
                      Trade Categories
                    </HeaderLink>
                  }
                >
                  <CategoryDropdown
                    categories={data.categories}
                    popularCategories={data.popularCategories}
                    siteSource={siteSource}
                  />
                </HoverMenu>
                <HoverMenu
                  menuItem={
                    <HeaderLink
                      href="/photos"
                      data-ga-category={GA_CATEGORY}
                      data-ga-action={`${GA_CATEGORY} - Clicked Browse Photos`}
                      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                    >
                      Photos
                    </HeaderLink>
                  }
                >
                  <Dropdown
                    items={data.photoCategories}
                    footer={{
                      key: '/photos',
                      value: 'View all photo categories',
                      desc: 'Photo'
                    }}
                    siteSource={siteSource}
                    sourceType="Photos"
                  />
                </HoverMenu>
                <HoverMenu
                  menuItem={
                    <HeaderLink
                      href="/articles"
                      data-ga-category={GA_CATEGORY}
                      data-ga-action={`${GA_CATEGORY} - Clicked Articles`}
                      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                    >
                      Articles
                    </HeaderLink>
                  }
                >
                  <Dropdown
                    items={data.articleCategories}
                    footer={{
                      key: '/articles',
                      value: 'View all article topics',
                      desc: 'Article'
                    }}
                    siteSource={siteSource}
                    sourceType="Topics"
                  />
                </HoverMenu>
                <HoverMenu
                  menuItem={
                    <HeaderLink
                      href="/c/cost"
                      data-ga-category={GA_CATEGORY}
                      data-ga-action={`${GA_CATEGORY} - Clicked Cost Guides`}
                      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
                    >
                      Cost Guides
                    </HeaderLink>
                  }
                  style={{ paddingRight: 0 }}
                >
                  <Dropdown
                    items={data.costGuides}
                    footer={{
                      key: '/articles',
                      value: 'View all cost guides',
                      desc: 'Cost Guide'
                    }}
                    siteSource={siteSource}
                    sourceType="Cost Guides"
                  />
                </HoverMenu>
              </HeaderList>
            </Col>
            <Col xs={0} md={4.5}>
              {loginData.logged_in ? (
                <LoggedIn {...loginData} siteSource={siteSource} />
              ) : (
                <LoggedOut siteSource={siteSource} />
              )}
            </Col>
          </Row>
          <Col xs={12} md={0} style={{ padding: 0 }}>
            <Mobile
              postcodeText={postcodeValue}
              siteText={siteValue}
              setHeaderPostcode={this.onPostcodeChange}
              setHeaderSite={this.onSiteChange}
              onSearchSubmit={this.onSearchSubmit}
              siteSource={siteSource}
            />
          </Col>
        </Container>
      </div>
    );
  }
}

const LoggedOut = ({ siteSource }) => (
  <HeaderList style={{ textAlign: 'right', paddingLeft: 0 }}>
    <HeaderLink
      href="/register"
      data-ga-category={GA_CATEGORY}
      data-ga-action={`${GA_CATEGORY} - Clicked Sign Up`}
      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
    >
      Register
    </HeaderLink>
    <HeaderLink
      href="/login"
      data-ga-category={GA_CATEGORY}
      data-ga-action={`${GA_CATEGORY} - Clicked Login`}
      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
    >
      Sign in
    </HeaderLink>
    <HeaderLink
      style={{
        paddingRight: 0
      }}
      href="/advertise"
      data-ga-category={GA_CATEGORY}
      data-ga-action={`${GA_CATEGORY} - Clicked List Your Business`}
      data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
    >
      <Button
        secondary
        style={{
          padding: 12,
          paddingTop: 8,
          paddingBottom: 6
        }}
      >
        List your business
      </Button>
    </HeaderLink>
  </HeaderList>
);

LoggedOut.propTypes = {
  siteSource: PropTypes.string
};

const Avatar = styled.img`
  border-radius: 100%;
  width: 30px;
  height: 30px;
`;

const UnreadMessages = styled.span`
 position: absolute;
    top: 3px;
    right: 0;
    display: block;
    background-color: ${props => props.theme.danger};
    border-radius: 100%;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    margin: 0;
    padding: 2px 5px;
    color: ${props => props.theme.snow}; !important;
`;

const LoggedIn = ({ number_messages, user_thumbnail, ...props }) => (
  <HeaderList style={{ textAlign: 'right', paddingLeft: 0 }}>
    <HeaderLink
      href="/message_centre"
      style={{ position: 'relative', fontSize: 26, marginRight: 10 }}
    >
      <span className="hui-icon-message" />
      <UnreadMessages>{number_messages}</UnreadMessages>
    </HeaderLink>
    <HoverMenu
      fancyArrow={false}
      menuItem={
        <HeaderLink>
          <Avatar
            src={`//avatar.homeimprovementpages.com.au/creative/users/${
              user_thumbnail
            }/140x140.jpg`}
          />
        </HeaderLink>
      }
    >
      <LoginDropdown {...props} />
    </HoverMenu>
  </HeaderList>
);

LoggedIn.propTypes = {
  number_messages: PropTypes.string,
  user_thumbnail: PropTypes.string
};
